import ProjectsItem from "./projects-item";

interface ProjectsProp {
  data: any;
  priority?: boolean;
}

const Projects: React.FC<ProjectsProp> = ({ data, priority = false }) => (
  <div className="projects-list">
    <div className="container">
      <div className="projects-list__inner">
        {data.Project.map((item: any, index: number) => (
          <ProjectsItem data={item} index={index} priority={priority && index < 3} key={index} />
        ))}
      </div>
    </div>
  </div>
);

export default Projects;
